
















































































































































import { dateFormat } from "@/utils/timeFormat";
import { getOrderMeritPayLessonDetailApi } from "@/api/salary";
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() originData!: {
    salary_id: number;
    staff_id: number;
    group_one_id: number;
    amount: string;
    range_type: number;
    experience_lesson_student: number;
    missed_class_lesson_consume: number;
    make_up_lesson_student: number;
  };
  dialogVisible = false;
  detailStartDate: string = "";
  detailEndDate: string = "";
  experienceLessonStudentCount: number = 0;
  missedClassLessonConsume: number = 0;
  mainCalculateType: number = 0;
  tableData: {}[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  goRollCallDetails(val: any) {
    const go = this.$router.resolve({
      name: "rollCallDetails",
      query: {
        id: val.roll_call_id,
      },
    });
    window.open(go.href, "_blank");
  }
  showDialog() {
    this.dialogVisible = true;
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  getList(params: { page: number; page_size: number }) {
    if (
      !this.originData.salary_id ||
      !this.originData.staff_id ||
      this.originData.group_one_id < 0
    ) {
      return false;
    }
    const option: any = {
      page: params.page,
      page_size: params.page_size,
      salary_id: this.originData.salary_id,
      staff_id: this.originData.staff_id,
      group_one_id: this.originData.group_one_id,
    };
    getOrderMeritPayLessonDetailApi(option).then((res: any) => {
      res.data.list.lesson_gradient.map((item: any) => {
        item.start_time = dateFormat(
          "YYYY-mm-dd HH:MM",
          new Date(item.start_time * 1000)
        );
      });
      this.tableData = res.data.list.lesson_gradient;
      this.detailStartDate = res.data.list.start_date;
      this.detailEndDate = res.data.list.end_date;
      this.experienceLessonStudentCount =
        res.data.list.salary_staff_order.experience_lesson_student;
      this.missedClassLessonConsume =
        res.data.list.salary_staff_order.missed_class_lesson_consume;
      this.mainCalculateType = res.data.list.salary_staff_order.calculate_type;
      this.total = res.data.total;
      this.page = res.data.page;
    });
  }
  tooltipText() {
    let content: string =
      this.originData.range_type === 2 ? "体验学员" : "未到课学员";
    if (this.originData.range_type === 2) {
      content =
        content + (this.originData.experience_lesson_student === 1 ? "" : "不");
    } else {
      content =
        content +
        (this.originData.missed_class_lesson_consume === 1 ? "" : "不");
    }
    return (content = content + "计算授课绩效");
  }
  sumLessonValueTotal(row: any) {
    let res = 0;
    row.gradient_list.map((item: any) => {
      res = res + Number(item.value);
    });
    return res.toFixed(2);
  }
  sumLessonRowTotal(row: any) {
    let res = Number(row.lesson_price);
    row.gradient_list.map((item: any) => {
      if (item.price_type === 1) {
        if (Number(item.value)) {
          // value为0时不命中任何梯度，不算入小计
          res = res + Number(item.unit_price);
        }
      } else {
        res = res + Number(item.value) * Number(item.unit_price);
      }
    });
    return res.toFixed(2);
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
